// Static FAQ copy for the /craft page. Shared by Craft.jsx (rendered UI) and
// frontend/scripts/prerender.js (FAQPage JSON-LD at build time) so the two
// can't drift out of sync — edit only here.
const craftFaqs = [
  {
    question: 'What exactly is a "recipe"?',
    answer:
      "A recipe is a named, reusable engineering pattern we've proven in production & not a one-off case study. It documents the approach so we can move faster and de-risk your build.",
  },
  {
    question: "What's the difference between Foundational, Composite, and Advanced?",
    answer:
      "Foundational recipes are single proven techniques. Composite recipes combine several into a working subsystem, like an eval suite for AI agents. Advanced recipes are multi-system patterns reserved for the hardest, highest-stakes builds.",
  },
  {
    question: "Do you build from a template, or from our actual problem?",
    answer:
      "From your problem. Recipes are starting points, not templates we force-fit. Every engagement starts with discovery scoped to your need.",
  },
  {
    question: "Is this a handoff, or do you stay involved?",
    answer:
      "A partnership through every phase - discovery, design, build, and launch. You're in the sprint demos and launch dashboards with us, not waiting on a delivery email.",
  },
];

module.exports = craftFaqs;
